import React from 'react'

function Numbers({
  countTotalConsumptions,
  countIPv4s,
  countHostnames})
{
  function makeNumber(name, value) {
    return (
      <div className="level-item has-text-centered">
        <div>
          <p className="heading has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">{name}</p>
          <p className="title honey-text honey-text-font-family-mono">{value}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="block">
      <div className="level">
        {makeNumber("Hostnames", countHostnames)}
        {makeNumber("IPs", countIPv4s)}
        {makeNumber("Connections", countTotalConsumptions)}
      </div>
    </div>
  );
}

export default Numbers;
